export function getClientApplicationContext<T>(caller: T) {
  if (!globalThis.initializeClientApplicationContext) {
    throw new Error('Application context is not defined');
  }

  return globalThis.initializeClientApplicationContext(caller);
}

export function getClientApplicationConfig() {
  if (!globalThis.initializeClientApplicationConfig) {
    throw new Error('Application config is not defined');
  }

  return globalThis.initializeClientApplicationConfig();
}
